import React, { useState, useEffect } from "react";
import api from "../../services/api";
import { toast } from "react-toastify";
import { LuDatabase, LuTrash2, LuRefreshCw, LuDownload, LuSearch } from "react-icons/lu";

const AdminData = ({ isSidebarOpen = true }) => {
    const [tables, setTables] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        fetchTables();
    }, []);

    const fetchTables = async () => {
        setLoading(true);
        try {
            const response = await api.get("/admin/tables");
            if (response.data.status === "success") {
                setTables(response.data.data);
            }
        } catch (error) {
            console.error("Failed to fetch tables", error);
            toast.error("Failed to load tables");
        } finally {
            setLoading(false);
        }
    };

    const handleClearTable = async (tableName) => {
        if (
            !window.confirm(
                `Are you sure you want to clear all data from table "${tableName}"? This action cannot be undone!`
            )
        ) {
            return;
        }

        try {
            const response = await api.post("/admin/clear-table", { tableName });
            if (response.data.status === "success") {
                toast.success(`Table ${tableName} cleared successfully`);
            }
        } catch (error) {
            console.error("Failed to clear table", error);
            toast.error(error.response?.data?.message || "Failed to clear table data");
        }
    };

    const filteredTables = tables.filter((table) =>
        table.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            <div className={`${isSidebarOpen ? "col-lg-9" : "col-lg-12"} pt-4 pb-2 pb-sm-4`}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h2 className="d-flex align-items-center mb-0">
                        <LuDatabase className="text-primary me-2" size={30} />
                        Database Management
                    </h2>
                    <button className="btn btn-sm btn-outline-primary d-flex align-items-center gap-2" onClick={fetchTables}>
                        <LuRefreshCw className={loading ? "spin" : ""} /> Refresh
                    </button>
                </div>

                <div className="card border-0 shadow-sm">
                    <div className="card-body">
                        <div className="">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h5 className="mb-0">Tables ({tables.length})</h5>
                                </div>
                                <div className="col-auto">
                                    <div className="input-group">
                                        <span className="input-group-text bg-light border-end-0 p-1">
                                            <LuSearch className="text-muted" />
                                        </span>
                                        <input
                                            type="text"
                                            className="form-control  p-0"
                                            placeholder="Search tables..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="overflow-auto">
                            <table className="table table-hover align-middle mb-0">
                                <thead className="bg-light">
                                    <tr>
                                        <th className="ps-4">Table Name</th>
                                        <th className="text-end pe-4">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="2" className="text-center py-5 text-muted">
                                                Loading tables...
                                            </td>
                                        </tr>
                                    ) : filteredTables.length > 0 ? (
                                        filteredTables.map((table) => (
                                            <tr key={table}>
                                                <td className="ps-4 fw-medium text-primary">{table}</td>
                                                <td className="text-end pe-4">
                                                    <button
                                                        className="btn btn-sm btn-outline-danger d-inline-flex align-items-center gap-2"
                                                        onClick={() => handleClearTable(table)}
                                                    >
                                                        <LuTrash2 size={14} /> Clear Data
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="2" className="text-center py-5 text-muted">
                                                No tables found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div className="mt-3 text-muted small">
                    <p className="mb-0">
                        <strong>Note:</strong> Clearing a table permanently deletes all rows. This cannot be undone.
                    </p>
                </div>
            </div>
        </>
    );
};

export default AdminData;
